import React, { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import PageHeader from "../components/ui/PageHeader";
import ContactList from "../components/contacts/ContactList";
import ContactForm from "../components/contacts/ContactForm";
import ContactDetail from "../components/contacts/ContactDetail";
import ContactImport from "../components/contacts/ContactImport";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add, ImportExport } from "@mui/icons-material";

const ContactsPage = () => {
  const { contactId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [editingContact, setEditingContact] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, []);
  const handleEdit = (contact) => {
    setEditingContact(contact);
    setShowForm(true);
  };

  const handleView = (contact) => {
    navigate(`/contacts/${contact.id}`);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingContact(null);
    setRefreshKey((k) => k + 1);
  };

  const handleImportSuccess = () => {
    setShowImport(false);
    setRefreshKey((k) => k + 1);
  };

  // Si hay un contactId en la URL, mostrar el detalle
  if (contactId) {
    return (
      <Box>
        <ContactDetail
          contactId={contactId}
          onEdit={(contact) => {
            setEditingContact(contact);
            setShowForm(true);
          }}
        />
        
        {/* Dialog de edición también disponible desde el detalle */}
        <Dialog
          key={editingContact?.id || "new"}
          open={showForm}
          onClose={() => setShowForm(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "24px",
              maxHeight: "90vh",
            },
          }}
        >
          <DialogContent sx={{ p: 0 }}>
            <ContactForm
              contact={editingContact}
              onSave={() => {
                handleSave();
                navigate("/contacts");
              }}
              onCancel={() => setShowForm(false)}
            />
          </DialogContent>
        </Dialog>
      </Box>
    );
  }

  return (
    <Box>
      <PageHeader
        title="Contactos"
        action={
          <Box sx={{ display: "flex", gap: 1 }}>
          </Box>
        }
      />
      <ContactList 
        key={refreshKey} 
        onEdit={handleEdit} 
        onView={handleView}
      />

      {/* Dialog de formulario */}
      <Dialog
        key={editingContact?.id || "new"}
        open={showForm}
        onClose={() => setShowForm(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <ContactForm
            contact={editingContact}
            onSave={handleSave}
            onCancel={() => setShowForm(false)}
          />
        </DialogContent>
      </Dialog>

      {/* Dialog de importación */}
      <Dialog
        open={showImport}
        onClose={() => setShowImport(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <ContactImport
            onSuccess={handleImportSuccess}
            onCancel={() => setShowImport(false)}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ContactsPage;